import { TYPE_SIZES as s, TYPES_BUTTON as t } from "../../utils/index.js";
import r from "../Loader/index.js";
import { resolveComponent as d, openBlock as i, createBlock as c, resolveDynamicComponent as m, mergeProps as u, withCtx as f, createElementBlock as p, createVNode as h, createCommentVNode as _, createElementVNode as y, renderSlot as b, createTextVNode as k } from "vue";
import g from "../../_virtual/index.js";
const B = {
  name: "ButtonControl",
  components: {
    Loader: r
  },
  props: {
    nativeType: {
      type: String,
      default: "button"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: s.normal.value
    },
    isAddedDisabledClassName: {
      type: Boolean,
      default: !1
    },
    isWhiteLoader: {
      type: Boolean,
      default: !1
    },
    isBlock: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "default"
    },
    isMultiLines: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  computed: {
    rootClass() {
      return [
        {
          [t.secondary.className]: this.type === t.secondary.value,
          [t.more.className]: this.type === t.more.value,
          [t.link.className]: this.type === t.link.value,
          [t.linkDashed.className]: this.type === t.linkDashed.value,
          [s.small.className]: this.size === s.small.value,
          [s.extraSmall.className]: this.size === s.extraSmall.value,
          [s.large.className]: this.size === s.large.value,
          _loading: this.loading,
          _disabled: this.isAddedDisabledClassName,
          _block: this.isBlock,
          "_multi-lines": this.isMultiLines
        }
      ];
    },
    computeAttrs() {
      const e = Object.assign({}, this.$attrs);
      return this.isTagLink || (e.type = this.nativeType), e;
    },
    isTagLink() {
      return this.tag === "a";
    }
  },
  mounted() {
    var e, l;
    (e = this.$refs) != null && e.root.classList.contains("_two-lines") && console.warn('[ButtonControl] className "_two-lines" is deprecated'), (l = this.$refs) != null && l.root.classList.contains("_split") && console.warn('[ButtonControl] className "_split" is deprecated');
  },
  methods: {
    handleClick(e) {
      this.$emit("click", e);
    }
  }
}, C = {
  key: 0,
  class: "b24-btn__loading"
}, N = { class: "b24-btn__content" }, v = /* @__PURE__ */ k("\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C");
function S(e, l, a, L, T, o) {
  const n = d("loader");
  return i(), c(m(a.tag), u({
    ref: "root",
    class: ["b24-btn", o.rootClass]
  }, o.computeAttrs, {
    disabled: a.disabled,
    onClick: o.handleClick
  }), {
    default: f(() => [
      a.loading ? (i(), p("span", C, [
        h(n, {
          class: "b24-btn__loader",
          "is-white": a.isWhiteLoader
        }, null, 8, ["is-white"])
      ])) : _("", !0),
      y("span", N, [
        b(e.$slots, "default", {}, () => [
          v
        ])
      ])
    ]),
    _: 3
  }, 16, ["class", "disabled", "onClick"]);
}
const z = /* @__PURE__ */ g(B, [["render", S]]);
export {
  z as default
};
